import React from 'react';
import { observer } from 'mobx-react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import MarkerClusterer from "react-google-maps/lib/components/addons/MarkerClusterer";

import MapConf from './MapConf';
import { getMarkerIcon } from './MarkerIcons';

const clusterStyles = [
  {
    textColor: 'white',
    url: '/images/clusterimage-sm.svg',
    height: 40,
    width: 40
  },
 {
    textColor: 'white',
    url: '/images/clusterimage-md.svg',
    height: 50,
    width: 50
  },
 {
    textColor: 'white',
    url: '/images/clusterimage-lg.svg',
    height: 60,
    width: 60
  }
];

@withScriptjs
@withGoogleMap
@observer
class CustomMap extends React.Component {

	render() {
		console.log('render map');
		const google = window.google;
		return (
		<GoogleMap defaultZoom={14} defaultCenter={{ lat: 45.4628328, lng: 9.1876925 }} defaultOptions={{ styles: MapConf.styles }}>

			<MarkerClusterer averageCenter maxZoom={15} enableRetinaIcons gridSize={45} styles={clusterStyles}>
			{ this.props.stateStore.filteredPOIS.map( (item, ndx) => (
				<Marker position={item.latLng} key={item.label} icon={{
					url: getMarkerIcon(item, this.props.stateStore)
					,scaledSize: new google.maps.Size(25,57) }} />
			) ) }
			</MarkerClusterer>

		</GoogleMap>
		);
	}
}

export { CustomMap };
